import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Coinflip } from '@models/coinflip.interface';
import { CoinflipCoinComponent } from '@shared/coinflip-coin/coinflip-coin.component';
import { IconComponent } from '@shared/icon/icon.component';
import { NamePipe } from '@shared/pipes/name.pipe';
import { TimeRemainingPipe } from '@shared/pipes/time-remaining.pipe';
import { UIService } from '@shared/ui.service';

@Component({
  selector: 'app-coinflip-modal-top',
  templateUrl: './coinflip-modal-top.component.html',
  styleUrls: ['./coinflip-modal-top.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, CoinflipCoinComponent, AsyncPipe, TimeRemainingPipe, NamePipe],
})
export class CoinflipModalTopComponent {
  @Input() coinflip: Coinflip;
  animationEnded = false;
  constructor(public uiService: UIService) {}

  animStart() {
    this.uiService.playSound('cf', { maxVolume: 0.5 });
  }

  animEnd() {
    this.animationEnded = true;
  }
}
